import { C } from '../lib/theme';
import { styles } from '../lib/styles';

interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const map: Record<string, { bg: string; color: string; label: string }> = {
    IN_REVIEW: { bg: C.infoBg, color: C.info, label: 'In Review' },
    ONBOARDING: { bg: C.goldBg, color: C.goldText, label: 'Onboarding' },
    SUCCESSFUL: { bg: C.successBg, color: C.success, label: 'Successful' },
    UNSUCCESSFUL: { bg: C.dangerBg, color: C.danger, label: 'Unsuccessful' },
    APPEAL: { bg: C.warnBg, color: C.warn, label: 'Appeal' },
    CURE_WINDOW: { bg: C.warnBg, color: C.warn, label: 'Cure Window' },
    FINAL_DETERMINATION: { bg: C.specialBg, color: C.special, label: 'Final Determination' },
    CLOSED: { bg: C.neutralBg, color: C.neutral, label: 'Closed' },
    REVET_DUE: { bg: C.warnBg, color: C.warn, label: 'Re-Vet Due' },
    PENDING_DELETION: { bg: C.dangerBg, color: C.danger, label: 'Pending Deletion' },
    SYNCED: { bg: C.successBg, color: C.success, label: 'Synced' },
    PENDING_SYNC: { bg: C.warnBg, color: C.warn, label: 'Pending Sync' },
    OPEN: { bg: C.infoBg, color: C.info, label: 'Open' },
    EXPIRED: { bg: C.neutralBg, color: C.neutral, label: 'Expired' },
    SCHEDULED: { bg: C.infoBg, color: C.info, label: 'Scheduled' },
    REQUESTED: { bg: C.warnBg, color: C.warn, label: 'Requested' },
    AWAITING_RESPONSE: { bg: C.warnBg, color: C.warn, label: 'Awaiting Response' },
    COMPLETED: { bg: C.successBg, color: C.success, label: 'Completed' },
    CHANGED: { bg: C.infoBg, color: C.info, label: 'Changed' },
    UNCHANGED: { bg: C.neutralBg, color: C.neutral, label: 'Unchanged' },
  };
  const s = map[status] || { bg: C.infoBg, color: C.info, label: status };
  return <span style={{ ...styles.badge, background: s.bg, color: s.color }}>{s.label}</span>;
}
